app.QuizStepList = app.AbstractCollection.extend({
  model: app.QuizStep,

  url() {
    return '/api/v2/quiz-steps';
  },
});
